<template>
    <div class="all-sec-comment">
        <Loading v-if="!loadingDone"/>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多啦~"
            :error.sync="error"
            error-text="请求失败  点击重新加载"
            @load="onCommentLoad"
            :offset=100
            :immediate-check="false"
            v-if="loadingDone"
        >
            <van-cell class="user-comment-item" style="padding:0px;">
                <div class="user-avatar">
                    <img :src="oneLevelComment&&oneLevelComment.icon" alt="">
                </div>
                <div class="user-comment-detail" :data-role="oneLevelComment&&oneLevelComment.id">
                    <p class="user-name">{{oneLevelComment&&oneLevelComment.user_name}}<span style="float:right;color:#999">{{oneLevelComment&&oneLevelComment.created_at}}</span></p>
                    <p class="comment-cont">{{oneLevelComment&&oneLevelComment.content}}</p>
                </div>
                <ul class="second-level-comment">
                    <li v-for="(childItem,index) in twoLevelCommentList" :key="index">
                        <div class="user-avatar">
                            <img :src="childItem&&childItem.icon" alt="">
                        </div>
                        <div class="user-comment-detail">
                            <p class="user-name">{{childItem&&childItem.user_name}}<span style="float:right;color:#999">{{childItem&&childItem.created_at}}</span></p>
                            <p class="comment-cont">{{childItem&&childItem.content}}</p>
                        </div>
                    </li>
                    <!-- <div class="show-all-second-level-comment" v-if="fatherItem.many!==0" :data-role="fatherItem&&fatherItem.id" @click="getMoreTwoLevelComment">查看更多<van-icon name="arrow-down" /></div>
                    <div class="hide-all-second-level-comment" v-if="hideTwoLevelComment&&fatherItem.id==curHideBtnId" :data-role="fatherItem&&fatherItem.id" @click="hideMoreTwoLevelComment">收起<van-icon name="arrow-up" /></div> -->
                </ul>
            </van-cell>
        </van-list>
        <div :class="{'add-comment-box':true,'add-comment-box-focus':textareaFocus}">
            <textarea placeholder="想说点什么..." v-model="commentContent" @focus="changeCommentBoxHeight" @blur="textBlur" :class="{'textarea-focus':textareaFocus}"/>
            <button @click="addSecLevelComment" :disabled="sendBtnDisabled" :class="{'sending':commentSending,'btn-in-textarea-focus':textareaFocus}"  ref="sendBtn">发表</button>
        </div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import {GetCookie} from '@/assets/api/cookie'
import Loading from '@/components/Loading'
import notifyIcon from '@/assets/img/msgicon.png'
export default{
    name:'SecondComment',
    data(){
        return{
            loading: false,                     //控制上划加载状态显示
            finished: false,                    //控制上划加载完成状态显示
            error: false,                       //控制上划加载出错状态显示
            commentContent:'',                  //发送评论的评论内容
            forId:'',                           //二级评论for_id参数
            oneLevelComment:'',                 //一级评论
            twoLevelCommentList:[],             //储存二级评论
            commentPageNum:1,                   //二级评论分页
            sendBtnDisabled:false,              //控制评论发送按钮可点击状态 防重复提交
            commentSending:false,               //控制评论发送中按钮颜色
            haveMoreOneLevelComment:1,          //是否还有更多一级评论
            haveMoreTwoLevelComment:'',         //是否还有更多二级评论
            twoLevelCommentPageNum:0,           //获取二级评论页码参数
            hideTwoLevelComment:false,          //显示收起更多二级评论按钮
            curHideBtnId:'',                    //根据ID判断要显示收起按钮的评论
            getMoreIdChange:'',                 //判断点击查看更多的对应评论是否变化
            curCommentForId:'',                 //点击查看更多时储存返回二级评论的FOR_ID(父子级关系)
			loadingDone:false,                   //评论数据是否加载完成
			date:new Date(),                    //定义事件对象
			curTime:'',                         //每次进入页面获取实时的时间
			textareaFocus:false                 //判断评论输入框光标移入改变高度
        }
    },
    created(){
        //获取实时时间请求接口
		this.curTime=this.date.getFullYear()+'-'
		this.curTime=this.curTime+(this.date.getMonth()+1)+'-'
		this.curTime=this.curTime+(this.date.getDate())+' '
		this.curTime=this.curTime+(this.date.getHours())+':'
		this.curTime=this.curTime+(this.date.getMinutes())+':'
		this.curTime=this.curTime+(this.date.getSeconds())
        Axios.get('/comment/child/'+this.$route.query.for_id,{params:{page:this.commentPageNum,num:10,limittime:this.curTime}})
        .then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.oneLevelComment=response.data.data.first_data
                    this.twoLevelCommentList=response.data.data.list
                    this.loadingDone=true
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
        )
    },
    methods:{
        //屏幕往上滑动时加载评论
        onCommentLoad(){
            this.curTime=this.date.getFullYear()+'-'
		    this.curTime=this.curTime+(this.date.getMonth()+1)+'-'
		    this.curTime=this.curTime+(this.date.getDate())+' '
		    this.curTime=this.curTime+(this.date.getHours())+':'
		    this.curTime=this.curTime+(this.date.getMinutes())+':'
		    this.curTime=this.curTime+(this.date.getSeconds())
            this.commentPageNum++
            console.log('显示页码',this.commentPageNum)
            Axios.get('/comment/child/'+this.$route.query.for_id,{params:{page:this.commentPageNum,num:10,limittime:this.curTime}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.twoLevelCommentList.push(...response.data.data.list)
                        console.log('加载更多二级',response.data.data.list)
                        this.loading=false
                    }
                }
            ).catch(
                error=>{
                    this.finished=true
                    //this.error=true;
                }
            )
        },
        //评论框输入区域失去焦点时
        textBlur(){
			if(this.commentContent==""){
				this.textareaFocus=false
			}
        },
        //改变评论输入框高度
		changeCommentBoxHeight(){
			this.textareaFocus=true
        },
        //添加二级评论
        addSecLevelComment(){
            if(GetCookie('token')){
				Axios.defaults.headers.common['Authorization']=GetCookie('token')
            }
            if(this.commentContent==""){
                this.$swal({
					text:'评论内容不能为空',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
                return false
            }
            this.sendBtnDisabled=true
            this.commentSending=true
            this.$refs.sendBtn.innerHTML="发送中..."
            //二级评论ID不为空提交二级评论
            Axios.post('/comment',{article_id:this.$route.query.id,for_id:this.$route.query.for_id,contents:this.commentContent})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.sendBtnDisabled=false
                        this.commentSending=false
                        this.$refs.sendBtn.innerHTML="发表"
                        this.commentContent=""
                        this.textareaFocus=false
                        this.$swal({
                            text:'发送成功 审核通过后会显示在评论区 请稍后',
                            showConfirmButton:false,
                            width:'6rem',
                            padding:'0.5rem',
                            timer:1200,
                            imageWidth:50,
                            imageHeight:50,
                            imageUrl:notifyIcon,
                            timerProgressBar: true
                        });
                    }
                }
            ).catch(
                error=>{
                    this.sendBtnDisabled=true
                    this.commentSending=true
                    this.$refs.sendBtn.innerHTML="发表"
                    if(error.response.data.code==422){
                        this.$swal({
                            text:'未登录或登录超时 请重新登录',
                            showConfirmButton:false,
                            width:'6rem',
                            padding:'0.5rem',
                            timer:800,
                            imageWidth:50,
                            imageHeight:50,
                            imageUrl:notifyIcon,
                            timerProgressBar: true
                        })
                        setTimeout(()=>{
                            location.href='/login'
                        },800)
                    }else{
                        this.$swal({
                            text:'网络错误请稍后重试',
                            showConfirmButton:false,
                            width:'6rem',
                            padding:'0.5rem',
                            timer:1000,
                            imageWidth:50,
                            imageHeight:50,
                            imageUrl:notifyIcon,
                            timerProgressBar: true
                        });
                    }
                }
            )
        }
    },
    components:{
        Loading
    }
}
</script>

<style scoped lang="scss">
    .all-sec-comment{
        position:relative;
        padding:120px 45px 110px 45px;
        width:660px;
        .van-cell:not(:last-child)::after{
            border-bottom:none;
        }
        .user-comment-item{
            overflow:hidden;
            .user-avatar{
                width:62px;
                height:62px;
                margin-right:16px;
                float:left;
                img{
                    width:100%;
                    height:100%;
                    border-radius:50%;
                }
            }
            .user-comment-detail{
                width:580px;
                float:left;
                .user-name{
                    height:21px;
                    font-size:22px;
                    color:#222;
                    margin-bottom:24px;
                }
                .comment-cont{
                    font-size:22px;
                    color:#999;
                    line-height:36px;
                }
            }
            .second-level-comment{
                width:582px;
                float:right;
                margin-top:22px;
                border-radius:10px;
                li{
                    padding:38px 22px;
                    overflow:hidden;
                    margin-bottom:18px;
                    background:#F8F6F7;
                }
                .user-comment-detail{
                    width:420px;
                }
                .show-all-second-level-comment,.hide-all-second-level-comment{
                    font-size:20px;
                    color:#999;
                    margin-bottom:26px;
                    .van-icon-arrow-down,.van-icon-arrow-up{
                        margin-left:10px;
                        transform:translateY(2px);
                    }
                }
            }
        }
        .add-comment-box{
            position:fixed;
            bottom:0;
            left:0;
            width:750px;
            height:110px;
            line-height:110px;
            background:#fffeff;
            box-shadow:0px -1px 4px #F5F5F5;
            textarea{
                position:absolute;
                left:18px;
                top:50%;
                transform:translateY(-33px);
                width:516px;
                height:30px;
                padding:16px 16px 16px 16px;
                line-height:24px;
                border:none;
                background:#F8F6F7;
                color:#999;
                border-radius:35px;
                margin-right:12px;
                font-size:24px;
                resize:none;
            }
            textarea::placeholder{
                color: #ccc !important;
                line-height:30px;
            }
            button{
                position:absolute;
                right:18px;
                top:50%;
                transform:translateY(-33px);
                display:inline-block;
                background:#bf0000;
                width:152px;
                height:66px;
                line-height:64px;
                border-radius:35px;
                text-align:center;
                color:#fff;
                font-size:24px;
                border:none;
            }
            button:active{
                background:#DD8080;
            }
            .sending{
                background:#DD8080;
            }
        }
        .add-comment-box-focus{
            height:200px !important;
        }
        .textarea-focus{
            height:120px !important;
            transform:translateY(-78px) !important;
        }
        .btn-in-textarea-focus{
            height:152px !important;
            transform:translateY(-78px) !important;
        }
    }
</style>